var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PageWrapDefault',[(_vm.editing?.status)?_c('div',{staticClass:"flex items-end justify-end"},[_c('p',{staticClass:"text-atlas-blue border border-atlas-blue px-6 py-2 rounded"},[_vm._v(" "+_vm._s(_vm.editing?.status)+" ")])]):_vm._e(),_c('DisplayData',{attrs:{"data":_vm.sectionData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }